import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class ProjectActionsService {
	projectDeleting: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	projectCreating: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() { }
}
